import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

// Phone-only sheet for pickers, filters and "More". Headless UI's Dialog
// gives the focus trap, Esc, outside-click close and scroll lock. Bounded to
// 85% of the viewport (landscape phones included) with its own scroll.
export default function BottomSheet({ open, onClose, title, footer, children }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="fixed inset-x-0 bottom-0 flex justify-center">
        <DialogPanel
          data-testid="bottom-sheet-panel"
          className="flex w-full flex-col rounded-t-2xl bg-surface shadow-xl dark:bg-gray-800"
          style={{ maxHeight: 'calc(85vh - var(--playground-banner-height, 0px))' }}
        >
          <div className="mx-auto mt-2 h-1 w-9 flex-none rounded-full bg-gray-300 dark:bg-gray-600" aria-hidden="true" />
          <div className="flex flex-none items-center justify-between pl-4 pr-2">
            <DialogTitle className="text-[17px] font-semibold text-gray-900 dark:text-gray-100">{title}</DialogTitle>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="flex h-11 w-11 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:text-gray-400 dark:hover:bg-gray-700"
            >
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-4">{children}</div>
          {footer ? (
            <div className="flex-none border-t border-gray-200/70 px-4 pt-3 pb-[max(env(safe-area-inset-bottom),1rem)] dark:border-gray-600/70">{footer}</div>
          ) : (
            <div className="flex-none pb-[env(safe-area-inset-bottom)]" />
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
